'use client';

import React from 'react';
import Link from 'next/link';
import { Button } from '@/components/ui/button';
import { Hero } from '@/components/ui/Hero';
import { FORM_SECTION_ID } from '../../consts';
import { SECTION_ID } from '../working-together-section';
import {
  REQUEST_CONSULTATION_HERO_DESC,
  REQUEST_CONSULTATION_HERO_TITLE,
} from './consts';

function RequestConsultationHero() {
  return (
    <Hero
      title={REQUEST_CONSULTATION_HERO_TITLE}
      desc={REQUEST_CONSULTATION_HERO_DESC}
    >
      <Button asChild>
        <Link href={`#SECTION-${FORM_SECTION_ID}`}>
          Request your Consultation Now
        </Link>
      </Button>

      <Button asChild variant="secondary">
        <Link href={`#SECTION-${SECTION_ID}`}>How Does it Work?</Link>
      </Button>
    </Hero>
  );
}

export default RequestConsultationHero;
